<template>
  <div>
    <div>
      <h3>Lucky Family Brand Account List</h3>
      <table class="table table-striped table-bordered table-hover table-condensed">
        <thead>
        <tr>
          <th>#</th>
          <th class="assign_text_left">Shop Name</th>
          <th class="assign_text_left">Email</th>
          <th class="assign_text_left">LFB Points</th>
          <th class="assign_text_left">Redeemed</th>
          <th class="assign_text_left">Remaining</th>
          <th class="assign_text_left">Last LFB Signin</th>
          <th class="assign_text_left">Last LFB Order</th>
          <th class="assign_text_left">Order Size</th>
          <th class="assign_text_left">Password</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="account in accounts_list" v-bind:key="account.cognitousername">
          <td>{{account.pos}}</td>

<!--          <td style="cursor: pointer; text-decoration: underline" v-on:click="show_customer_detail_page(account.license, account.userid)">{{account.companyname}}</td>-->
          <td>{{account.companyname}}</td>

          <template v-if="account.is_confirmed === 1">
            <td class="assign_text_left">{{account.cognitousername}}</td>
          </template>
          <template v-else>
            <td class="assign_text_left red_text">{{account.cognitousername}} - Not Confirmed</td>
          </template>
          <td class="assign_text_left">{{account.total_reward_points}}</td>
          <td class="assign_text_left">{{account.total_rewards_redeemed}}</td>
          <td class="assign_text_left">{{account.reward_remaining}}</td>
          <td style="white-space:nowrap;" class="assign_text_left">{{account.signedin_date_formatted}}</td>
          <td style="white-space:nowrap;" class="assign_text_left">{{account.last_lfb_order_date}}</td>

          <td class="assign_text_left">{{account.order_size}}</td>

          <td>
            <template v-if="account.password">
              {{account.password}}
            </template>
            <template v-else>
              <button @click="get_password_in_agent_list(account.userid)" class="password_button">Show</button>
            </template>
          </td>

        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      accounts_list: 'admin/accounts_list',
    }),
  },
  mounted() {
    this.getAccountList();
  },
  props: {
  },
  methods: {
    // show_customer_detail_page(license_number, userid) {
    //   this.$router.push({name: "account_details", 'params':{license_number,userid}});
    // },
    getAccountList () {
      this.$store.dispatch('admin/getAccountList',{userid_pw: ''} );
    },
    get_password_in_agent_list(userid) {
      this.$store.dispatch('admin/getAccountList',{userid_pw: userid});
    },
  }
}
</script>

<style scoped>

.password_button {
  font-size: 16px;
  color: black;
  background-color: salmon;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 800;
}

.red_text {
  color: red;
}

input {
  padding: 3px;
  padding-left: 7px;
  width:250px;
  font-size: 20px;
  color: blue;
}

.assign_text_left {
  text-align: left;
}


</style>
